import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Icon } from '../../icon/Icon';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../../hooks/store/useStore';
import { firstPageSlice } from '../../../../store/firstPageSlice';
import { pageInfo } from '../../../../constants/pageInfo/pageInfo.constant';
import { BackButtonProps } from '../MainHead';

export const BackButton = ({ backButton }: { backButton: BackButtonProps }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const dispatch = useAppDispatch();
  const { isFirstPageHasBackButton } = useAppSelector((state) => state.firstPage);
  const { setIsFirstPageHasBackButton } = firstPageSlice.actions;
  const [isFromLogin, setIsFromLogin] = useState<boolean>(false);

  useEffect(() => {
    if (backButton.isShow && isFirstPageHasBackButton === false && location.key === 'default') {
      dispatch(setIsFirstPageHasBackButton(true));
    }
  }, [backButton.isShow, isFirstPageHasBackButton, location.key]);

  useEffect(() => {
    if (location.state?.loginFinished) {
      setIsFromLogin(true);
    }
  }, [location.state]);

  const handleBackButtonClick = () => {
    if (backButton.isShow && backButton.directlyPassedURL && isFromLogin) {
      navigate(backButton.directlyPassedURL);
      return;
    }

    // 최초 진입 페이지가 back button이 없었거나 (정상적인 상황, 브라우저 히스토리를 그대로 이용해도 됨), 로그인 직후가 아닌 경우
    if (!isFirstPageHasBackButton) {
      navigate(-1);
      return;
    }

    // 최초 진입 페이지가 back button이 있었다면 (예외적인 상황, 브라우저 히스토리를 그대로 이용하면 외부 페이지로 갈 수도 있으므로 이용하면 안됨)
    // 페이지를 이동하기 전에, 브라우저 히스토리를 이용할 수 있는 정상적인 상황으로 돌아가므로 전역 상태 변경
    dispatch(setIsFirstPageHasBackButton(false));

    // 직접 지정한 페이지가 있다면 해당 페이지로 이동
    if (backButton.isShow && backButton.directlyPassedURL) {
      navigate(backButton.directlyPassedURL);
      return;
    }

    // 직접 지정한 페이지가 없다면 홈 페이지로 이동
    navigate(pageInfo.homePage.path);
  };

  return (
    <BackButtonContainer>
      <Button
        type={'button'}
        onClick={() => {
          handleBackButtonClick();
          backButton.onClick?.();
        }}
      >
        <Icon name={'ArrowLeft'} size={'XLarge'} />
      </Button>
    </BackButtonContainer>
  );
};

const BackButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;

  padding-right: 16px;
`;

const Button = styled.button``;
